import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          尼尼研究室Nel's Studio (Test Project)<br/>
        </p>
      </header>
    </div>
  );
}

export default App;
